"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateViaRef = exports.updateModels = void 0;
const execute_logic_1 = __importDefault(require("./execute-logic"));
const resolvers_1 = require("./resolvers");
const type_conversion_1 = require("./type-conversion");
const functional_1 = require("./functional");
const constants_1 = require("../constants");
const run_validations_1 = __importDefault(require("./run-validations"));
const getValue = (models, repeatIndex) => node => typeof node === 'object' && node.type
    ? (0, execute_logic_1.default)({ ast: node, data: { models, repeatIndex } })
    : node;
const getCurrentValue = modelItem => modelItem.meta &&
    modelItem.meta.fieldValueAttr &&
    modelItem[modelItem.meta.fieldValueAttr];
const updateModel = ({ modelItem, meta, validationData, ...attrs }) => {
    const currentValue = getCurrentValue(modelItem);
    Object.entries(attrs).forEach(([key, value]) => {
        modelItem[key] = value;
    });
    // if meta is present, then properties need to be set on the model's `meta`
    if (meta) {
        if (!modelItem.meta) {
            modelItem.meta = {};
        }
        Object.entries(meta).forEach(([key, value]) => {
            modelItem.meta[key] = value;
        });
    }
    if (currentValue !== getCurrentValue(modelItem)) {
        (0, run_validations_1.default)(modelItem, validationData);
    }
};
const updateModels = ({ models, modelRef, repeatIndex, ...attrs }) => {
    const modelIds = (0, resolvers_1.resolveModelIds)({ models, modelRef, repeatIndex });
    modelIds.forEach(({ index, id }) => {
        updateModel({
            modelItem: models[index][id],
            validationData: { models, repeatIndex },
            ...attrs,
        });
    });
    return models;
};
exports.updateModels = updateModels;
const updateViaRef = ({ modelRef, models, value, normalizer = val => val, repeatIndex, }) => {
    if (Array.isArray(modelRef)) {
        modelRef.forEach(r => {
            (0, exports.updateViaRef)({
                modelRef: r,
                models,
                value,
                normalizer,
                repeatIndex,
            });
        });
        return models;
    }
    const { attr } = modelRef;
    // eslint-disable-next-line no-use-before-define
    return (0, exports.updateModels)({
        models,
        modelRef,
        ...(value !== undefined
            ? {
                [attr || constants_1.MODEL_CONTENTS]: (0, functional_1.pipe)(value)(getValue(models, repeatIndex), normalizer, type_conversion_1.equivalentString),
            }
            : {}),
        repeatIndex,
    });
};
exports.updateViaRef = updateViaRef;
//# sourceMappingURL=update-model.js.map